import { NB } from '@cerebral-inc/ui';
import { LayoutProps } from './types';
import { ReactComponent as Logo } from './images/logo.svg';

const { Flex, Box, Center } = NB;

const AssessmentLayout = ({ children, isGradientBackground }: LayoutProps) => {
  return (
    <div
      style={{
        background: isGradientBackground
          ? 'linear-gradient(135deg, #FEF9EC 0%, #ECEFFE 100%)'
          : '#ffffff'
      }}
    >
      <Flex>
        <Box>
          <Center
            py="20px"
            borderColor="#FFFFFF"
            borderBottomColor="#F0F1F5"
            borderWidth="1px"
          >
            <Logo width={85} height={16} />
          </Center>
        </Box>

        <Center>{children}</Center>
      </Flex>
    </div>
  );
};

export default AssessmentLayout;
